// #1549 プロフィール画像の事前チェック。サーバー側（ProfileImageUploader）と同じ条件で、
// 送信前に拡張子とサイズを見る（ドラッグ&ドロップは input の accept を通らないため、ここで止める）。
export const PROFILE_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png']
// サーバー側の 5.megabytes と同じバイト数
export const PROFILE_IMAGE_MAX_BYTES = 5 * 1024 * 1024
export const PROFILE_IMAGE_HINT = 'JPG・PNG(5MBまで)'

// 問題があれば画面に出す文言を、なければ null を返す
export function profileImageError(file) {
  const extension = (file.name.includes('.') ? file.name.split('.').pop() : '').toLowerCase()
  if (!PROFILE_IMAGE_EXTENSIONS.includes(extension)) {
    return `JPG・PNG の画像を選んでください(${file.name})`
  }
  if (file.size === 0) return '空のファイルはアップロードできません'
  if (file.size > PROFILE_IMAGE_MAX_BYTES) return '5MB以下の画像を選んでください'
  return null
}
